<template>
  <div
    :class="[
      `tooltip`,
      isOpen && `tooltip--open`,
      isDark && `tooltip--dark`,
      isOneLine && `tooltip--one-line`,
      position === `top-center` && `tooltip--center`,
      position === `top-right` && `tooltip--right`,
      position === `below-left` && `tooltip--below`,
      position === `below-center` && `tooltip--center tooltip--below`,
      position === `below-right` && `tooltip--right tooltip--below`,
      position === `right-top` && `tooltip--right-top`,
      position === `left-top` && `tooltip--left-top`,
    ]"
    aria-describedby="tooltip__text_id"
    tabindex="0"
  >
    <strong v-if="isBold">{{ label }}</strong>
    <span v-else>{{ label }}</span>
    <div class="tooltip__wrapper" aria-hidden="true">
      <div id="tooltip__text_id" class="tooltip__text">{{ text }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tooltip",
  props: {
    /**
     * @description
     * Provides the Text for Display.
     * In case of showing tooltip, we need to call the Tooltip Component,
     * Pass the label and the text. Label for Display and Text for tooltip text.
     */
    text: {
      type: String,
      default: "Default Tooltip Text",
    },
    /**
     * @description
     * Provides the Label for Display.
     * In case of showing tooltip, we need to call the Tooltip Component,
     * Pass the label and the text. Label for Display and Text for tooltip text.
     */
    label: {
      type: String,
      default: "Default Tooltip Label",
    },
    /**
     * @description
     * Provides the position for the Tooltip Text.
     */
    position: {
      type: String,
      validator: (val) =>
        [
          "top-left",
          "top-center",
          "top-right",
          "below-left",
          "below-center",
          "below-right",
          "right-top",
          "left-top",
        ].includes(val),
      default: "top-left",
    },
    /**
     * @description
     * Flag to open & close the tooltip
     * We will generally call the tooltip component from block or inline tag such as.
     * We can use vue events such as mousehover & mouseleave to trigger a method on the block or inline tag that calls tooltip and update the state of the parent. Once the state is updated the child (tooltip) will open or close based on the state
     */
    isOpen: {
      type: Boolean,
      default: false,
    },
    /**
     * @description
     * Flag to show tooltip with white or black background
     */
    isDark: {
      type: Boolean,
      default: false,
    },
    /**
     * @description
     * Flag to show long tooltip text in one line or multiple lines
     */
    isOneLine: {
      type: Boolean,
      default: false,
    },
    /**
     * @description
     * Flag to show long tooltip text in bold or normal state
     */
    isBold: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.tooltip {
  display: inline-block !important;
}
</style>